module.exports = __webpack_public_path__ + "static/landing-aa47a3039055af5b5bc656d94f6624cd.png";